import { Button as ButtonAntD } from 'antd';
import styled from 'styled-components';

import { hexToRgb } from '../../../../utils/hexToRgb/hexToRgb';
import { COLORS } from '../../../../utils/theme/colors';

export const Wrapper = styled.div`
  margin: 0 auto;

  .ant-page-header-back-button:focus,
  .ant-page-header-back-button:hover {
    color: ${({ theme }) => theme.primary};
  }
`;

export const Blank = styled.div`
  background-color: #fff;
  border-radius: 3px;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.21);
  margin: 0 24px;
  padding: 32px;
  width: 1090px;

  .search {
    .ant-input,
    .ant-input-affix-wrapper {
      transition: border-color 0.3s ease;
      &:hover,
      &:active,
      &:focus {
        border-color: ${({ theme }) => theme.primary} !important;
      }
    }

    .ant-input-search-button {
      transition: border-color 0.3s ease;
      &:hover,
      &:active,
      &:focus {
        border-color: ${({ theme }) => theme.primary} !important;
        border-left-color: ${({ theme }) => theme.primary} !important;
      }
    }
  }
`;

export const Legend = styled.div`
  padding: 16px;
  font-weight: 300;
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
  margin-bottom: 24px;
`;

export const TableWrapper = styled.div`
  margin-bottom: 24px;

  .ant-table-thead > tr > th {
    background-color: #fff;
    font-weight: 300;
  }

  .ant-table-tbody > tr > td {
    font-weight: 300;
  }

  .ant-table-tbody > tr.ant-table-row-selected > td {
    background: ${({ theme }) => `rgba(${hexToRgb(theme.primary)}, .1)`};
  }

  .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner,
  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: ${({ theme }) => theme.primary};
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${({ theme }) => theme.primary};
    border-color: ${({ theme }) => theme.primary};
  }

  .ant-checkbox-indeterminate .ant-checkbox-inner::after {
    background-color: ${({ theme }) => theme.primary};
  }

  .ant-pagination-item-active,
  .ant-pagination-item:focus,
  .ant-pagination-item:hover {
    border-color: ${({ theme }) => theme.primary};
    a {
      color: ${({ theme }) => theme.primary};
    }
  }

  .ant-pagination-item,
  .ant-pagination-item-link,
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border-radius: 3px;
  }

  .ant-pagination-prev:focus .ant-pagination-item-link,
  .ant-pagination-next:focus .ant-pagination-item-link,
  .ant-pagination-prev:hover .ant-pagination-item-link,
  .ant-pagination-next:hover .ant-pagination-item-link {
    border-color: ${({ theme }) => theme.primary};
    color: ${({ theme }) => theme.primary};
  }

  .ant-select:not(.ant-select-disabled):hover .ant-select-selector {
    border-color: ${({ theme }) => theme.primary};
  }

  &:focus {
    box-shadow: 0 0 2px ${({ theme }) => theme.primary};
  }

  .ant-select.ant-pagination-options-size-changer.ant-select-single.ant-select-show-arrow.ant-select-focused
    .ant-select-selector {
    border-color: ${({ theme }) => theme.primary};
  }

  .ant-select-focused:not(.ant-select-disabled).ant-select:not(
      .ant-select-customize-input
    )
    .ant-select-selector {
    box-shadow: 0 0 2px ${({ theme }) => theme.primary};
    border-color: ${({ theme }) => theme.primary};
  }

  .ant-select-item-option-selected {
    background-color: ${({ theme }) => theme.hoveredDiv};
  }

  .ant-pagination-jump-prev
    .ant-pagination-item-container
    .ant-pagination-item-link-icon,
  .ant-pagination-jump-next
    .ant-pagination-item-container
    .ant-pagination-item-link-icon {
    color: ${({ theme }) => theme.primary};
  }
`;

export const ChargeboxesSelectedText = styled.div`
  font-weight: 300;
`;

export const Button = styled(ButtonAntD)`
  height: 50px;
  padding-left: 32px;
  padding-right: 32px;
  border-radius: 3px;

  &.ant-btn-primary {
    background-color: ${({ theme }) => theme.primary};
    border-color: ${({ theme }) => theme.primary};
  }

  &.ant-btn:not(.ant-btn-primary):not(.ant-btn-dangerous) {
    &:hover {
      border-color: ${({ theme }) => theme.primary};
      color: ${({ theme }) => theme.primary};
    }
  }
`;

export const Bullet = styled.div`
  background-color: ${({ active }: { active: boolean }) =>
    COLORS[active ? 'popular' : 'busy']};
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin: auto;
`;
